// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"580":"ebcb25f7","787":"937c7cb2","803":"d0fc4752","901":"a98bd1c0"}[chunkId] + ".chunk.js";
};